/** @generated */ export const officialEmotes = {
    ':deviantart:': {
        name: ':deviantart:',
        src: '/d/deviantart.png',
        width: '12',
        height: '19'
    },
    ':)': {
        name: ':)',
        src: '/s/smile.gif',
        width: '15',
        height: '15'
    },
    ':D': {
        name: ':D',
        src: '/b/biggrin.gif',
        width: '15',
        height: '15'
    },
    '=P': {
        name: '=P',
        src: '/r/razz.gif',
        width: '15',
        height: '15'
    },
    ';P': {
        name: ';P',
        src: '/w/winkrazz.gif',
        width: '15',
        height: '15'
    },
    ';)': {
        name: ';)',
        src: '/w/wink.gif',
        width: '15',
        height: '15'
    },
    ':|': {
        name: ':|',
        src: '/b/blankstare.gif',
        width: '15',
        height: '15'
    },
    ':(': {
        name: ':(',
        src: '/f/frown.gif',
        width: '15',
        height: '15'
    },
    ':cries:': {
        name: ':cries:',
        src: '/c/cries.gif',
        width: '23',
        height: '15'
    },
    ':o': {
        name: ':o',
        src: '/e/eek.gif',
        width: '15',
        height: '15'
    },
    '^^;': {
        name: '^^;',
        src: '/a/animesweat.gif',
        width: '19',
        height: '19'
    },
    ':clap:': {
        name: ':clap:',
        src: '/c/clap2.gif',
        width: '20',
        height: '20'
    },
    ':dummy:': {
        name: ':dummy:',
        src: '/d/dummy.gif',
        width: '21',
        height: '15'
    },
    ':love:': {
        name: ':love:',
        src: '/l/love2.gif',
        width: '26',
        height: '17'
    },
    ':meow:': {
        name: ':meow:',
        src: '/m/meow.gif',
        width: '15',
        height: '15'
    },
    ':la:': {
        name: ':la:',
        src: '/l/la.gif',
        width: '19',
        height: '19'
    },
    ':nod:': {
        name: ':nod:',
        src: '/n/nod.gif',
        width: '15',
        height: '15'
    },
    ':giggle:': {
        name: ':giggle:',
        src: '/g/giggle.gif',
        width: '17',
        height: '15'
    },
    ':oops:': {
        name: ':oops:',
        src: '/r/redface.gif',
        width: '15',
        height: '15'
    },
    ':no:': {
        name: ':no:',
        src: '/n/no.gif',
        width: '15',
        height: '15'
    },
    ':rage:': {
        name: ':rage:',
        src: '/r/rage.gif',
        width: '15',
        height: '15'
    },
    ':hug:': {
        name: ':hug:',
        src: '/h/hug.gif',
        width: '38',
        height: '15'
    },
    ':shakefist:': {
        name: ':shakefist:',
        src: '/s/shakefist.gif',
        width: '24',
        height: '18'
    },
    ':happybounce:': {
        name: ':happybounce:',
        src: '/h/happybounce.gif',
        width: '17',
        height: '23'
    },
    ':faint:': {
        name: ':faint:',
        src: '/f/faint.gif',
        width: '18',
        height: '17'
    },
    ':huggle:': {
        name: ':huggle:',
        src: '/h/huggle.gif',
        width: '35',
        height: '17'
    },
    ':dalogo:': {
        name: ':dalogo:',
        src: '/d/dalogo1.gif',
        width: '16',
        height: '16'
    },
    ':+fav:': {
        name: ':+fav:',
        src: '/p/plusfav.gif',
        width: '15',
        height: '16'
    },
    ':heart:': {
        name: ':heart:',
        src: '/h/heart.gif',
        width: '15',
        height: '13'
    },
    ':groups:': {
        name: ':groups:',
        src: '/g/groups.gif',
        width: '16',
        height: '17'
    },
    ':points:': {
        name: ':points:',
        src: '/p/points.gif',
        width: '20',
        height: '14'
    },
    ':lonely:': {
        name: ':lonely:',
        src: '/l/lonely2.gif',
        width: '15',
        height: '15'
    },
    ':doh:': {
        name: ':doh:',
        src: '/d/doh.gif',
        width: '15',
        height: '15'
    },
    ':yawn:': {
        name: ':yawn:',
        src: '/y/yawn2.gif',
        width: '17',
        height: '15'
    },
    ':bored:': {
        name: ':bored:',
        src: '/b/bored.gif',
        width: '19',
        height: '15'
    },
    ':roll:': {
        name: ':roll:',
        src: '/r/rolleyes.gif',
        width: '15',
        height: '15'
    },
    ':stare:': {
        name: ':stare:',
        src: '/s/stare.gif',
        width: '15',
        height: '15'
    },
    ':grump:': {
        name: ':grump:',
        src: '/g/grump.gif',
        width: '17',
        height: '15'
    },
    ':nuu:': {
        name: ':nuu:',
        src: '/n/nuu.gif',
        width: '17',
        height: '16'
    },
    ':facepalm:': {
        name: ':facepalm:',
        src: '/f/facepalm.gif',
        width: '15',
        height: '15'
    },
    ':saddummy:': {
        name: ':saddummy:',
        src: '/s/saddummy.gif',
        width: '21',
        height: '19'
    },
    ':shifty:': {
        name: ':shifty:',
        src: '/s/shifty.gif',
        width: '22',
        height: '18'
    },
    ':crying:': {
        name: ':crying:',
        src: '/c/crying.gif',
        width: '20',
        height: '17'
    },
    ':dead:': {
        name: ':dead:',
        src: '/d/dead.gif',
        width: '15',
        height: '15'
    },
    ':disbelief:': {
        name: ':disbelief:',
        src: '/d/disbelief.gif',
        width: '15',
        height: '15'
    },
    ':ohnoes:': {
        name: ':ohnoes:',
        src: '/o/ohnoes.gif',
        width: '15',
        height: '15'
    },
    'B-)': {
        name: 'B-)',
        src: '/c/cool.gif',
        width: '15',
        height: '15'
    },
    ':shrug:': {
        name: ':shrug:',
        src: '/s/shrug2.gif',
        width: '19',
        height: '19'
    },
    ':zombie:': {
        name: ':zombie:',
        src: '/z/zombie.gif',
        width: '19',
        height: '19'
    },
    ':sneeze:': {
        name: ':sneeze:',
        src: '/s/sneeze2.gif',
        width: '19',
        height: '22'
    },
    ':sing:': {
        name: ':sing:',
        src: '/s/sing.gif',
        width: '29',
        height: '20'
    },
    ':nana:': {
        name: ':nana:',
        src: '/n/nanana.gif',
        width: '21',
        height: '15'
    },
    ':horny:': {
        name: ':horny:',
        src: '/h/horny2.gif',
        width: '15',
        height: '15'
    },
    ':greetings:': {
        name: ':greetings:',
        src: '/g/greetings.gif',
        width: '15',
        height: '15'
    },
    ':innocent:': {
        name: ':innocent:',
        src: '/i/innocent.gif',
        width: '17',
        height: '22'
    },
    ':psychotic:': {
        name: ':psychotic:',
        src: '/p/psychotic.gif',
        width: '15',
        height: '15'
    },
    ':woohoo:': {
        name: ':woohoo:',
        src: '/w/woohoo.gif',
        width: '31',
        height: '17'
    },
    ':headbang:': {
        name: ':headbang:',
        src: '/h/headbang.gif',
        width: '47',
        height: '16'
    },
    ':wave:': {
        name: ':wave:',
        src: '/w/wave1.gif',
        width: '25',
        height: '20'
    },
    ':boing:': {
        name: ':boing:',
        src: '/b/boing.gif',
        width: '9',
        height: '17'
    },
    ':airborne:': {
        name: ':airborne:',
        src: '/a/airborne.gif',
        width: '49',
        height: '36'
    },
    ':evillaugh:': {
        name: ':evillaugh:',
        src: '/m/mwahaha.gif',
        width: '29',
        height: '15'
    },
    ':plotting:': {
        name: ':plotting:',
        src: '/p/plotting.gif',
        width: '18',
        height: '20'
    },
    ':devilish:': {
        name: ':devilish:',
        src: '/d/devilish.gif',
        width: '15',
        height: '16'
    },
    ':blushes:': {
        name: ':blushes:',
        src: '/b/blushes.gif',
        width: '15',
        height: '15'
    },
    ':ashamed:': {
        name: ':ashamed:',
        src: '/a/ashamed2.gif',
        width: '22',
        height: '25'
    },
    ':ohmygod:': {
        name: ':ohmygod:',
        src: '/o/ohmygod.gif',
        width: '26',
        height: '18'
    },
    ':O_o:': {
        name: ':O_o:',
        src: '/w/weirdface2.gif',
        width: '15',
        height: '17'
    },
    ':confused:': {
        name: ':confused:',
        src: '/c/confuse.gif',
        width: '18',
        height: '15'
    },
    ':-?': {
        name: ':-?',
        src: '/c/confused.gif',
        width: '15',
        height: '30'
    },
    ':sherlock:': {
        name: ':sherlock:',
        src: '/s/sherlock.gif',
        width: '31',
        height: '27'
    },
    ':hmm:': {
        name: ':hmm:',
        src: '/h/hmm2.gif',
        width: '15',
        height: '15'
    },
    ':B': {
        name: ':B',
        src: '/b/bucktooth.gif',
        width: '15',
        height: '15'
    },
    ':tantrum:': {
        name: ':tantrum:',
        src: '/t/tantrum.gif',
        width: '19',
        height: '19'
    },
    ':bleh:': {
        name: ':bleh:',
        src: '/b/bleh.gif',
        width: '15',
        height: '15'
    },
    ':unimpressed:': {
        name: ':unimpressed:',
        src: '/u/unimpressed.gif',
        width: '15',
        height: '15'
    },
    ':w00t:': {
        name: ':w00t:',
        src: '/w/w00t.gif',
        width: '23',
        height: '23'
    },
    ':excited:': {
        name: ':excited:',
        src: '/e/excited.gif',
        width: '23',
        height: '19'
    },
    ':#1:': {
        name: ':#1:',
        src: '/n/number1.gif',
        width: '35',
        height: '31'
    },
    ':salute:': {
        name: ':salute:',
        src: '/s/salute.gif',
        width: '26',
        height: '18'
    },
    ':worship:': {
        name: ':worship:',
        src: '/w/worships.gif',
        width: '19',
        height: '19'
    },
    ':chew:': {
        name: ':chew:',
        src: '/c/chewing.gif',
        width: '16',
        height: '16'
    },
    ':popcorn:': {
        name: ':popcorn:',
        src: '/p/popcorn2.gif',
        width: '27',
        height: '34'
    },
    ':hungry:': {
        name: ':hungry:',
        src: '/h/hungry2.gif',
        width: '27',
        height: '27'
    },
    ':brushteeth:': {
        name: ':brushteeth:',
        src: '/b/brushteeth.gif',
        width: '27',
        height: '19'
    },
    ':meditation:': {
        name: ':meditation:',
        src: '/m/meditate.gif',
        width: '29',
        height: '23'
    },
    ':dalove:': {
        name: ':dalove:',
        src: '/d/dalove.gif',
        width: '29',
        height: '28'
    },
    ':+favlove:': {
        name: ':+favlove:',
        src: '/f/favheart.gif',
        width: '15',
        height: '14'
    },
    ':trophy:': {
        name: ':trophy:',
        src: '/t/trophy.gif',
        width: '15',
        height: '17'
    },
    ':fella:': {
        name: ':fella:',
        src: '/f/fella.gif',
        width: '15',
        height: '15'
    },
    ':devart:': {
        name: ':devart:',
        src: '/d/devart.gif',
        width: '32',
        height: '17'
    },
    ':fear:': {
        name: ':fear:',
        src: '/f/fear.gif',
        width: '18',
        height: '18'
    },
    ':omg:': {
        name: ':omg:',
        src: '/o/omg.gif',
        width: '15',
        height: '15'
    },
    ':shocked:': {
        name: ':shocked:',
        src: '/s/shocked.gif',
        width: '20',
        height: '19'
    },
    ':omfg:': {
        name: ':omfg:',
        src: '/o/omfg.gif',
        width: '15',
        height: '20'
    },
    ':blush:': {
        name: ':blush:',
        src: '/b/blush2.gif',
        width: '15',
        height: '16'
    },
    ':petting:': {
        name: ':petting:',
        src: '/p/petting.gif',
        width: '35',
        height: '15'
    },
    ':handshake:': {
        name: ':handshake:',
        src: '/h/handshake.gif',
        width: '40',
        height: '15'
    },
    ':happycry:': {
        name: ':happycry:',
        src: '/h/happycry2.gif',
        width: '15',
        height: '15'
    },
    ':flirty:': {
        name: ':flirty:',
        src: '/f/flirty.gif',
        width: '30',
        height: '26'
    },
    ':drool:': {
        name: ':drool:',
        src: '/d/drool.gif',
        width: '15',
        height: '18'
    },
    ':smoking:': {
        name: ':smoking:',
        src: '/s/smoking.gif',
        width: '24',
        height: '20'
    },
    ':raincloud:': {
        name: ':raincloud:',
        src: '/r/raincloud.gif',
        width: '24',
        height: '27'
    },
    ':sarcasm:': {
        name: ':sarcasm:',
        src: '/s/sarcasm.gif',
        width: '15',
        height: '15'
    },
    ':sarcasticclap:': {
        name: ':sarcasticclap:',
        src: '/s/sarcasticclap.gif',
        width: '23',
        height: '15'
    },
    ':slap:': {
        name: ':slap:',
        src: '/s/slap.gif',
        width: '33',
        height: '23'
    },
    ':typerhappy:': {
        name: ':typerhappy:',
        src: '/t/typerhappy.gif',
        width: '31',
        height: '17'
    },
    ':dance:': {
        name: ':dance:',
        src: '/d/dance.gif',
        width: '29',
        height: '21'
    },
    ':boogie:': {
        name: ':boogie:',
        src: '/b/boogie.gif',
        width: '25',
        height: '25'
    },
    ':eager:': {
        name: ':eager:',
        src: '/e/eager.gif',
        width: '18',
        height: '15'
    },
    ':squee:': {
        name: ':squee:',
        src: '/s/squee.gif',
        width: '37',
        height: '25'
    },
    ':ninja:': {
        name: ':ninja:',
        src: '/n/ninja.gif',
        width: '19',
        height: '19'
    },
    ':winner:': {
        name: ':winner:',
        src: '/w/winner.gif',
        width: '15',
        height: '29'
    },
    ':wizardhat:': {
        name: ':wizardhat:',
        src: '/w/wizardhat.png',
        width: '18',
        height: '18'
    },
    ':judge:': {
        name: ':judge:',
        src: '/j/judge.gif',
        width: '25',
        height: '20'
    },
    ':stinkeye:': {
        name: ':stinkeye:',
        src: '/s/stinkeye.gif',
        width: '16',
        height: '18'
    },
    ':bulletgreen:': {
        name: ':bulletgreen:',
        src: '/b/bulletgreen.gif',
        width: '10',
        height: '10'
    },
    ':bulletred:': {
        name: ':bulletred:',
        src: '/b/bulletred.gif',
        width: '10',
        height: '10'
    },
    ':bulletblue:': {
        name: ':bulletblue:',
        src: '/b/bulletblue.gif',
        width: '10',
        height: '10'
    },
    ':bulletpurple:': {
        name: ':bulletpurple:',
        src: '/b/bulletpurple.gif',
        width: '10',
        height: '10'
    },
    ':bulletblack:': {
        name: ':bulletblack:',
        src: '/b/bulletblack.gif',
        width: '10',
        height: '10'
    },
    ':bulletwhite:': {
        name: ':bulletwhite:',
        src: '/b/bulletwhite.gif',
        width: '10',
        height: '10'
    },
    ':bulletyellow:': {
        name: ':bulletyellow:',
        src: '/b/bulletyellow.gif',
        width: '10',
        height: '10'
    },
    ':new:': {
        name: ':new:',
        src: '/n/new.gif',
        width: '30',
        height: '27'
    },
    ':bulletorange:': {
        name: ':bulletorange:',
        src: '/b/bulletorange.gif',
        width: '10',
        height: '10'
    },
    ':bulletpink:': {
        name: ':bulletpink:',
        src: '/b/bulletpink.gif',
        width: '10',
        height: '10'
    },
    ':note:': {
        name: ':note:',
        src: '/n/note.gif',
        width: '14',
        height: '14'
    },
    ':twitter:': {
        name: ':twitter:',
        src: '/t/twitter_2.gif',
        width: '16',
        height: '16'
    },
    ':facebook:': {
        name: ':facebook:',
        src: '/f/facebook.gif',
        width: '16',
        height: '16'
    },
    ':googleplus:': {
        name: ':googleplus:',
        src: '/g/googleplus1.gif',
        width: '16',
        height: '16'
    },
    ':+devwatch:': {
        name: ':+devwatch:',
        src: '/letters/+devwatch.gif',
        width: '30',
        height: '16'
    },
    ':fellaleft:': {
        name: ':fellaleft:',
        src: '/f/fellaleft.gif',
        width: '15',
        height: '15'
    },
    ':fellaright:': {
        name: ':fellaright:',
        src: '/f/fellaright.gif',
        width: '15',
        height: '15'
    },
    ':fellarectum:': {
        name: ':fellarectum:',
        src: '/f/fellarectum.gif',
        width: '15',
        height: '15'
    },
    ':daprints:': {
        name: ':daprints:',
        src: '/d/daprints.gif',
        width: '37',
        height: '28'
    },
    ':jarkorig:': {
        name: ':jarkorig:',
        src: '/j/jarkorig.gif',
        width: '14',
        height: '18'
    },
    ':jarksaber:': {
        name: ':jarksaber:',
        src: '/j/jarksaber.gif',
        width: '35',
        height: '24'
    },
    ':spyed:': {
        name: ':spyed:',
        src: '/s/spyed2.gif',
        width: '19',
        height: '32'
    },
    ':spyed2:': {
        name: ':spyed2:',
        src: '/s/spyed.gif',
        width: '20',
        height: '16'
    },
    ':katana:': {
        name: ':katana:',
        src: '/k/katana.gif',
        width: '40',
        height: '25'
    },
    ':ninjabattle:': {
        name: ':ninjabattle:',
        src: '/n/ninjabattle.gif',
        width: '91',
        height: '23'
    },
    ':ninjastar:': {
        name: ':ninjastar:',
        src: '/n/ninjastar.gif',
        width: '63',
        height: '21'
    },
    ':meditate:': {
        name: ':meditate:',
        src: '/n/ninjameditate.gif',
        width: '22',
        height: '24'
    },
    ':ninjaeat:': {
        name: ':ninjaeat:',
        src: '/n/ninjaeat.gif',
        width: '50',
        height: '30'
    },
    ':spot:': {
        name: ':spot:',
        src: '/s/spot.gif',
        width: '20',
        height: '20'
    },
    ':dygel:': {
        name: ':dygel:',
        src: '/d/dygel.gif',
        width: '28',
        height: '22'
    },
    ':kevin:': {
        name: ':kevin:',
        src: '/k/kevin.gif',
        width: '22',
        height: '33'
    },
    ':mikeylove:': {
        name: ':mikeylove:',
        src: '/m/mikeylove.gif',
        width: '15',
        height: '15'
    },
    ':jsenn:': {
        name: ':jsenn:',
        src: '/j/jsenn.gif',
        width: '20',
        height: '20'
    },
    ':lolly:': {
        name: ':lolly:',
        src: '/l/lolly.gif',
        width: '25',
        height: '21'
    },
    ':ekud:': {
        name: ':ekud:',
        src: '/e/ekud2.gif',
        width: '26',
        height: '19'
    },
    ':liquisoft:': {
        name: ':liquisoft:',
        src: '/l/liquisoft.gif',
        width: '11',
        height: '16'
    },
    ':ost2life:': {
        name: ':ost2life:',
        src: '/o/ost2life.gif',
        width: '28',
        height: '22'
    },
    ':phae:': {
        name: ':phae:',
        src: '/p/phae.gif',
        width: '16',
        height: '17'
    },
    ':neom:': {
        name: ':neom:',
        src: '/n/neom.gif',
        width: '23',
        height: '23'
    },
    ':fusionrock:': {
        name: ':fusionrock:',
        src: '/f/fusionrock.gif',
        width: '25',
        height: '20'
    },
    ':rzero:': {
        name: ':rzero:',
        src: '/r/rzero.gif',
        width: '19',
        height: '17'
    },
    ':leodadominico:': {
        name: ':leodadominico:',
        src: '/l/leodadominico.gif',
        width: '21',
        height: '21'
    },
    ':hprince:': {
        name: ':hprince:',
        src: '/h/hprince329.gif',
        width: '21',
        height: '21'
    },
    ':silentkitty:': {
        name: ':silentkitty:',
        src: '/s/silentkitty.gif',
        width: '25',
        height: '25'
    },
    ':mangapunksai:': {
        name: ':mangapunksai:',
        src: '/m/mangapunksai.gif',
        width: '25',
        height: '27'
    },
    ':hesitation:': {
        name: ':hesitation:',
        src: '/h/hesitation.gif',
        width: '25',
        height: '33'
    },
    ':alteredreality:': {
        name: ':alteredreality:',
        src: '/a/alteredreality.gif',
        width: '20',
        height: '20'
    },
    ':please:': {
        name: ':please:',
        src: '/p/please.gif',
        width: '15',
        height: '22'
    },
    ':fork:': {
        name: ':fork:',
        src: '/f/fork.gif',
        width: '37',
        height: '18'
    },
    ':nirvana:': {
        name: ':nirvana:',
        src: '/n/nirvana.gif',
        width: '18',
        height: '18'
    },
    ':below:': {
        name: ':below:',
        src: '/b/below.gif',
        width: '15',
        height: '15'
    },
    ':above:': {
        name: ':above:',
        src: '/a/above.gif',
        width: '15',
        height: '15'
    },
    ':lmao:': {
        name: ':lmao:',
        src: '/l/lmao.gif',
        width: '19',
        height: '21'
    },
    ':buymyprints:': {
        name: ':buymyprints:',
        src: '/b/buymyprints.gif',
        width: '55',
        height: '15'
    },
    ':tears:': {
        name: ':tears:',
        src: '/t/tears.gif',
        width: '15',
        height: '15'
    },
    ':strong:': {
        name: ':strong:',
        src: '/s/strong.gif',
        width: '35',
        height: '18'
    },
    ':b0x0rz:': {
        name: ':b0x0rz:',
        src: '/b/b0x0rz.gif',
        width: '18',
        height: '15'
    },
    ':sleep:': {
        name: ':sleep:',
        src: '/s/sleep.gif',
        width: '38',
        height: '22'
    },
    ':cowboy:': {
        name: ':cowboy:',
        src: '/c/cowboy.gif',
        width: '26',
        height: '22'
    },
    ':tux:': {
        name: ':tux:',
        src: '/t/tux.gif',
        width: '21',
        height: '22'
    },
    ':relaxed:': {
        name: ':relaxed:',
        src: '/r/relaxed.gif',
        width: '40',
        height: '30'
    },
    ':sun:': {
        name: ':sun:',
        src: '/s/sun.gif',
        width: '30',
        height: '30'
    },
    ':altermind:': {
        name: ':altermind:',
        src: '/a/altermind.gif',
        width: '19',
        height: '18'
    },
    ':blahblah:': {
        name: ':blahblah:',
        src: '/b/blahblah.gif',
        width: '37',
        height: '15'
    },
    ':shh:': {
        name: ':shh:',
        src: '/s/shh.gif',
        width: '17',
        height: '19'
    },
    ':juggle:': {
        name: ':juggle:',
        src: '/j/juggling.gif',
        width: '21',
        height: '21'
    },
    ':constipated:': {
        name: ':constipated:',
        src: '/c/constipated.gif',
        width: '15',
        height: '15'
    },
    ':whisper:': {
        name: ':whisper:',
        src: '/w/whisper2.gif',
        width: '30',
        height: '20'
    },
    ':floating:': {
        name: ':floating:',
        src: '/f/floating.gif',
        width: '34',
        height: '15'
    },
    ':invisible:': {
        name: ':invisible:',
        src: '/i/invisible.gif',
        width: '15',
        height: '15'
    },
    ':hump:': {
        name: ':hump:',
        src: '/h/hump.gif',
        width: '27',
        height: '17'
    },
    ':teamwork:': {
        name: ':teamwork:',
        src: '/t/teamwork2.gif',
        width: '40',
        height: '41'
    },
    ':sniff:': {
        name: ':sniff:',
        src: '/s/sniff.gif',
        width: '15',
        height: '15'
    },
    ':stfu:': {
        name: ':stfu:',
        src: '/s/stfu.gif',
        width: '28',
        height: '29'
    },
    ':steaming:': {
        name: ':steaming:',
        src: '/s/steaming.gif',
        width: '15',
        height: '24'
    },
    ':pissedoff:': {
        name: ':pissedoff:',
        src: '/p/pissedoff2.gif',
        width: '25',
        height: '25'
    },
    ':banned:': {
        name: ':banned:',
        src: '/b/ban.gif',
        width: '41',
        height: '38'
    },
    ':bounce:': {
        name: ':bounce:',
        src: '/b/bounce.gif',
        width: '40',
        height: '25'
    },
    ':picknose:': {
        name: ':picknose:',
        src: '/p/picknose.gif',
        width: '20',
        height: '30'
    },
    ':matrixfight:': {
        name: ':matrixfight:',
        src: '/m/matrixfight.gif',
        width: '91',
        height: '23'
    },
    ':XD:': {
        name: ':XD:',
        src: '/x/xd.gif',
        width: '15',
        height: '15'
    },
    ':eyepopping:': {
        name: ':eyepopping:',
        src: '/e/eyepopping.gif',
        width: '15',
        height: '15'
    },
    ':boo:': {
        name: ':boo:',
        src: '/b/boo2.gif',
        width: '30',
        height: '19'
    },
    ':w00t!:': {
        name: ':w00t!:',
        src: '/w/w00t.gif',
        width: '23',
        height: '23'
    },
    ':orange:': {
        name: ':orange:',
        src: '/o/orange.gif',
        width: '17',
        height: '28'
    },
    ':blowkiss:': {
        name: ':blowkiss:',
        src: '/b/blowkiss.gif',
        width: '35',
        height: '21'
    },
    ':pee:': {
        name: ':pee:',
        src: '/p/pee.gif',
        width: '45',
        height: '15'
    },
    ':shithitsthefan:': {
        name: ':shithitsthefan:',
        src: '/s/shithitsthefan.gif',
        width: '40',
        height: '20'
    },
    ':pills:': {
        name: ':pills:',
        src: '/p/pills.gif',
        width: '42',
        height: '17'
    },
    ':fart:': {
        name: ':fart:',
        src: '/f/fart2.gif',
        width: '30',
        height: '19'
    },
    ':crash:': {
        name: ':crash:',
        src: '/c/crash.gif',
        width: '35',
        height: '30'
    },
    ':sushi:': {
        name: ':sushi:',
        src: '/s/sushi2.gif',
        width: '15',
        height: '15'
    },
    ':spammer:': {
        name: ':spammer:',
        src: '/s/spammer.gif',
        width: '41',
        height: '38'
    },
    ':bookdiva:': {
        name: ':bookdiva:',
        src: '/b/bookdiva.gif',
        width: '32',
        height: '20'
    },
    ':shoutbox:': {
        name: ':shoutbox:',
        src: '/s/shoutbox.gif',
        width: '40',
        height: '22'
    },
    ':dj-designs:': {
        name: ':dj-designs:',
        src: '/d/dj-designs.gif',
        width: '26',
        height: '17'
    },
    ':toilet:': {
        name: ':toilet:',
        src: '/t/toilet.gif',
        width: '15',
        height: '19'
    },
    ':community:': {
        name: ':community:',
        src: '/c/community.gif',
        width: '57',
        height: '24'
    },
    ':cake:': {
        name: ':cake:',
        src: '/c/cake.gif',
        width: '32',
        height: '32'
    },
    ':date:': {
        name: ':date:',
        src: '/d/date.gif',
        width: '36',
        height: '22'
    },
    ':licking:': {
        name: ':licking:',
        src: '/l/licking.gif',
        width: '33',
        height: '15'
    },
    ':sprint:': {
        name: ':sprint:',
        src: '/s/sprint.gif',
        width: '101',
        height: '20'
    },
    ':granny:': {
        name: ':granny:',
        src: '/g/granny.gif',
        width: '25',
        height: '25'
    },
    ':tombstone:': {
        name: ':tombstone:',
        src: '/t/tombstone.gif',
        width: '21',
        height: '25'
    },
    ':stereo:': {
        name: ':stereo:',
        src: '/s/stereo.gif',
        width: '61',
        height: '23'
    },
    ':coffeemachine:': {
        name: ':coffeemachine:',
        src: '/c/coffeemachine.gif',
        width: '21',
        height: '31'
    },
    ':wtf:': {
        name: ':wtf:',
        src: '/w/wtf2.gif',
        width: '15',
        height: '15'
    },
    ':teddy:': {
        name: ':teddy:',
        src: '/t/teddy.gif',
        width: '32',
        height: '32'
    },
    ':bye:': {
        name: ':bye:',
        src: '/b/bye.gif',
        width: '25',
        height: '16'
    },
    ':flowerpot:': {
        name: ':flowerpot:',
        src: '/f/flowerpot.gif',
        width: '19',
        height: '28'
    },
    ':frustrated:': {
        name: ':frustrated:',
        src: '/f/frustrated.gif',
        width: '40',
        height: '25'
    },
    ':milk:': {
        name: ':milk:',
        src: '/m/milk.gif',
        width: '40',
        height: '25'
    },
    ':pray:': {
        name: ':pray:',
        src: '/p/prayer.gif',
        width: '15',
        height: '17'
    },
    ':reading:': {
        name: ':reading:',
        src: '/r/read.gif',
        width: '23',
        height: '21'
    },
    ':yoda:': {
        name: ':yoda:',
        src: '/y/yoda.gif',
        width: '40',
        height: '18'
    },
    ':phonecall:': {
        name: ':phonecall:',
        src: '/p/phonecall2.gif',
        width: '20',
        height: '19'
    },
    ':sick:': {
        name: ':sick:',
        src: '/s/sick2.gif',
        width: '23',
        height: '15'
    },
    ':party:': {
        name: ':party:',
        src: '/p/party2.gif',
        width: '36',
        height: '38'
    },
    ':headache:': {
        name: ':headache:',
        src: '/h/headache.gif',
        width: '16',
        height: '16'
    },
    ':puke:': {
        name: ':puke:',
        src: '/p/puke.gif',
        width: '24',
        height: '15'
    },
    ':censored:': {
        name: ':censored:',
        src: '/c/censor.gif',
        width: '38',
        height: '22'
    },
    ':stab:': {
        name: ':stab:',
        src: '/s/stab.gif',
        width: '24',
        height: '15'
    },
    ':sadangel:': {
        name: ':sadangel:',
        src: '/s/sadangel.gif',
        width: '88',
        height: '22'
    },
    ':twocents:': {
        name: ':twocents:',
        src: '/t/twocents.gif',
        width: '30',
        height: '15'
    },
    ':clueless:': {
        name: ':clueless:',
        src: '/c/clueless.gif',
        width: '52',
        height: '22'
    },
    ':rip:': {
        name: ':rip:',
        src: '/r/rip.gif',
        width: '39',
        height: '19'
    },
    ':earth:': {
        name: ':earth:',
        src: '/e/earth2.gif',
        width: '17',
        height: '17'
    },
    ':ignore:': {
        name: ':ignore:',
        src: '/i/ignore.gif',
        width: '26',
        height: '15'
    },
    ':couch:': {
        name: ':couch:',
        src: '/c/couch.gif',
        width: '47',
        height: '20'
    },
    ':pc:': {
        name: ':pc:',
        src: '/p/pc2.gif',
        width: '37',
        height: '22'
    },
    ':mobile:': {
        name: ':mobile:',
        src: '/m/mobile.gif',
        width: '11',
        height: '24'
    },
    ':bonk:': {
        name: ':bonk:',
        src: '/b/bonk.gif',
        width: '38',
        height: '28'
    },
    ':finger:': {
        name: ':finger:',
        src: '/f/finger.gif',
        width: '35',
        height: '16'
    },
    ':gallery:': {
        name: ':gallery:',
        src: '/g/gallery.gif',
        width: '47',
        height: '26'
    },
    ':jawdrop:': {
        name: ':jawdrop:',
        src: '/j/jawdrop.gif',
        width: '15',
        height: '32'
    },
    ':plug:': {
        name: ':plug:',
        src: '/p/plug.gif',
        width: '40',
        height: '17'
    },
    ':pointl:': {
        name: ':pointl:',
        src: '/p/pointl.gif',
        width: '11',
        height: '10'
    },
    ':pointr:': {
        name: ':pointr:',
        src: '/p/pointr.gif',
        width: '11',
        height: '10'
    },
    ':police:': {
        name: ':police:',
        src: '/p/police.gif',
        width: '26',
        height: '24'
    },
    ':rofl:': {
        name: ':rofl:',
        src: '/r/rofl.gif',
        width: '29',
        height: '27'
    },
    ':stupidme:': {
        name: ':stupidme:',
        src: '/s/stupidme2.gif',
        width: '30',
        height: '30'
    },
    ':tp:': {
        name: ':tp:',
        src: '/t/tp.gif',
        width: '22',
        height: '24'
    },
    ':windows:': {
        name: ':windows:',
        src: '/w/windows.gif',
        width: '18',
        height: '19'
    },
    ':batty:': {
        name: ':batty:',
        src: '/b/batty.gif',
        width: '19',
        height: '18'
    },
    ':pepsi:': {
        name: ':pepsi:',
        src: '/p/pepsi.gif',
        width: '20',
        height: '20'
    },
    ':relax:': {
        name: ':relax:',
        src: '/r/relax.gif',
        width: '31',
        height: '23'
    },
    ':donut:': {
        name: ':donut:',
        src: '/d/donut.gif',
        width: '20',
        height: '20'
    },
    ':camera:': {
        name: ':camera:',
        src: '/c/camera.gif',
        width: '15',
        height: '20'
    },
    ':gummybear:': {
        name: ':gummybear:',
        src: '/g/gummybear.gif',
        width: '15',
        height: '20'
    },
    ':pride:': {
        name: ':pride:',
        src: '/p/pride.gif',
        width: '15',
        height: '15'
    },
    ':spin:': {
        name: ':spin:',
        src: '/s/spin.gif',
        width: '17',
        height: '17'
    },
    ':sunnysideup:': {
        name: ':sunnysideup:',
        src: '/s/sunnysideup.gif',
        width: '30',
        height: '17'
    },
    ':mechabug:': {
        name: ':mechabug:',
        src: '/m/mechabug.gif',
        width: '27',
        height: '29'
    },
    ':nerd:': {
        name: ':nerd:',
        src: '/n/nerd.gif',
        width: '20',
        height: '21'
    },
    ':depressed:': {
        name: ':depressed:',
        src: '/d/depressed.gif',
        width: '15',
        height: '15'
    },
    ':jasinski:': {
        name: ':jasinski:',
        src: '/j/jasinski.gif',
        width: '15',
        height: '20'
    },
    ':slow:': {
        name: ':slow:',
        src: '/i/imslow.gif',
        width: '19',
        height: '19'
    },
    ':chainsaw:': {
        name: ':chainsaw:',
        src: '/c/chainsaw.gif',
        width: '49',
        height: '20'
    },
    ':pissed:': {
        name: ':pissed:',
        src: '/p/pissed.gif',
        width: '15',
        height: '20'
    },
    ':stupid:': {
        name: ':stupid:',
        src: '/s/stupid.gif',
        width: '44',
        height: '46'
    },
    ':bump:': {
        name: ':bump:',
        src: '/b/bump.gif',
        width: '45',
        height: '15'
    },
    ':brainless:': {
        name: ':brainless:',
        src: '/b/brainless.gif',
        width: '15',
        height: '15'
    },
    ':alientwo:': {
        name: ':alientwo:',
        src: '/a/alientwo.gif',
        width: '21',
        height: '15'
    },
    ':coffeecup:': {
        name: ':coffeecup:',
        src: '/c/coffeecup.gif',
        width: '16',
        height: '20'
    },
    ':dollarus:': {
        name: ':dollarus:',
        src: '/d/dollarus.gif',
        width: '16',
        height: '8'
    },
    ':email:': {
        name: ':email:',
        src: '/e/email.gif',
        width: '16',
        height: '11'
    },
    ':emailsend:': {
        name: ':emailsend:',
        src: '/e/emailsend.gif',
        width: '27',
        height: '11'
    },
    ':fuzzydemon:': {
        name: ':fuzzydemon:',
        src: '/f/fuzzydemon.gif',
        width: '15',
        height: '15'
    },
    ':idea:': {
        name: ':idea:',
        src: '/i/idea.gif',
        width: '15',
        height: '32'
    },
    ':pokeball:': {
        name: ':pokeball:',
        src: '/p/pokeball.gif',
        width: '16',
        height: '16'
    },
    ':target:': {
        name: ':target:',
        src: '/t/target.gif',
        width: '15',
        height: '15'
    },
    ':cheese:': {
        name: ':cheese:',
        src: '/c/cheese.gif',
        width: '16',
        height: '16'
    },
    ':moon:': {
        name: ':moon:',
        src: '/c/colonmooncolon.gif',
        width: '15',
        height: '15'
    },
    ':absolut:': {
        name: ':absolut:',
        src: '/a/absolut.gif',
        width: '10',
        height: '25'
    },
    ':bucktooth:': {
        name: ':bucktooth:',
        src: '/b/bucktooth.gif',
        width: '15',
        height: '15'
    },
    ':dizzy:': {
        name: ':dizzy:',
        src: '/d/dizzy.gif',
        width: '15',
        height: '15'
    },
    ':matteo:': {
        name: ':matteo:',
        src: '/m/matteo.gif',
        width: '30',
        height: '25'
    },
    ':attila:': {
        name: ':attila:',
        src: '/a/attila.gif',
        width: '16',
        height: '18'
    },
    ':tack:': {
        name: ':tack:',
        src: '/t/tack.gif',
        width: '18',
        height: '15'
    },
    ':brazensix:': {
        name: ':brazensix:',
        src: '/b/brazensix.gif',
        width: '18',
        height: '24'
    },
    ':fight:': {
        name: ':fight:',
        src: '/f/fight.gif',
        width: '15',
        height: '15'
    },
    ':furious:': {
        name: ':furious:',
        src: '/f/furious.gif',
        width: '15',
        height: '15'
    },
    ':macos:': {
        name: ':macos:',
        src: '/m/macos.gif',
        width: '15',
        height: '15'
    },
    ':megaphone:': {
        name: ':megaphone:',
        src: '/m/megaphone.gif',
        width: '17',
        height: '16'
    },
    ':painter:': {
        name: ':painter:',
        src: '/p/painter.gif',
        width: '34',
        height: '29'
    },
    ':sheepish:': {
        name: ':sheepish:',
        src: '/s/sheepish.gif',
        width: '20',
        height: '20'
    },
    ':spidey:': {
        name: ':spidey:',
        src: '/s/spidey.gif',
        width: '17',
        height: '20'
    },
    ':thumbsup:': {
        name: ':thumbsup:',
        src: '/t/thumbsup.gif',
        width: '15',
        height: '15'
    },
    ':thumbsdown:': {
        name: ':thumbsdown:',
        src: '/t/thumbsdown.gif',
        width: '15',
        height: '15'
    },
    ':music:': {
        name: ':music:',
        src: '/m/music.gif',
        width: '15',
        height: '15'
    },
    ':cd:': {
        name: ':cd:',
        src: '/c/compactdisk.gif',
        width: '16',
        height: '16'
    },
    ':bug:': {
        name: ':bug:',
        src: '/b/bug.gif',
        width: '15',
        height: '15'
    },
    ':frog:': {
        name: ':frog:',
        src: '/f/frog.gif',
        width: '15',
        height: '15'
    },
    ':batman:': {
        name: ':batman:',
        src: '/b/batman.gif',
        width: '15',
        height: '18'
    },
    ':weed:': {
        name: ':weed:',
        src: '/w/weed.gif',
        width: '20',
        height: '19'
    },
    ':devil:': {
        name: ':devil:',
        src: '/d/devil2.gif',
        width: '24',
        height: '19'
    },
    ':lightbulb:': {
        name: ':lightbulb:',
        src: '/l/lightbulb2.gif',
        width: '11',
        height: '16'
    },
    ':tmnt1:': {
        name: ':tmnt1:',
        src: '/t/tmnt1.gif',
        width: '15',
        height: '15'
    },
    ':tmnt2:': {
        name: ':tmnt2:',
        src: '/t/tmnt2.gif',
        width: '15',
        height: '15'
    },
    ':tmnt3:': {
        name: ':tmnt3:',
        src: '/t/tmnt3.gif',
        width: '15',
        height: '15'
    },
    ':tmnt4:': {
        name: ':tmnt4:',
        src: '/t/tmnt4.gif',
        width: '15',
        height: '15'
    },
    ':ladybug:': {
        name: ':ladybug:',
        src: '/l/ladybug.gif',
        width: '15',
        height: '15'
    },
    ':bomb:': {
        name: ':bomb:',
        src: '/b/bomb.gif',
        width: '15',
        height: '15'
    },
    ':moo:': {
        name: ':moo:',
        src: '/c/cow.gif',
        width: '15',
        height: '15'
    },
    ':kiss:': {
        name: ':kiss:',
        src: '/k/kiss2.gif',
        width: '17',
        height: '12'
    },
    ':eyes:': {
        name: ':eyes:',
        src: '/e/eyes.gif',
        width: '15',
        height: '15'
    },
    ':fish:': {
        name: ':fish:',
        src: '/f/fish.gif',
        width: '24',
        height: '19'
    },
    ':spork:': {
        name: ':spork:',
        src: '/s/spork.gif',
        width: '20',
        height: '20'
    },
    ':beer:': {
        name: ':beer:',
        src: '/b/beer.gif',
        width: '15',
        height: '15'
    },
    ':crazy:': {
        name: ':crazy:',
        src: '/c/crazy.gif',
        width: '15',
        height: '15'
    },
    ':pumpkin:': {
        name: ':pumpkin:',
        src: '/p/pumpkin.gif',
        width: '15',
        height: '15'
    },
    ':monitor:': {
        name: ':monitor:',
        src: '/m/monitor.gif',
        width: '15',
        height: '15'
    },
    ':magnify:': {
        name: ':magnify:',
        src: '/m/magnify.gif',
        width: '15',
        height: '15'
    },
    ':pencil:': {
        name: ':pencil:',
        src: '/p/pencil.gif',
        width: '15',
        height: '15'
    },
    ':flagus:': {
        name: ':flagus:',
        src: '/f/flag_usa.gif',
        width: '20',
        height: '13'
    },
    ':superman:': {
        name: ':superman:',
        src: '/s/superman.gif',
        width: '19',
        height: '13'
    },
    ':house:': {
        name: ':house:',
        src: '/h/house.gif',
        width: '20',
        height: '16'
    },
    ':spam:': {
        name: ':spam:',
        src: '/s/spam.gif',
        width: '25',
        height: '21'
    },
    ':alien:': {
        name: ':alien:',
        src: '/a/alien.gif',
        width: '15',
        height: '15'
    },
    ':drunk:': {
        name: ':drunk:',
        src: '/d/drunk.gif',
        width: '25',
        height: '28'
    },
    ':gun:': {
        name: ':gun:',
        src: '/g/gun.gif',
        width: '15',
        height: '15'
    },
    ':cylon:': {
        name: ':cylon:',
        src: '/c/cylon.gif',
        width: '16',
        height: '16'
    },
    ':evileyes:': {
        name: ':evileyes:',
        src: '/e/evileyes.gif',
        width: '15',
        height: '15'
    },
    ':horns:': {
        name: ':horns:',
        src: '/h/horns.gif',
        width: '16',
        height: '16'
    },
    ':poo:': {
        name: ':poo:',
        src: '/p/poo.gif',
        width: '15',
        height: '15'
    },
    ':rose:': {
        name: ':rose:',
        src: '/r/rose.gif',
        width: '15',
        height: '15'
    },
    ':flame:': {
        name: ':flame:',
        src: '/f/flame.gif',
        width: '15',
        height: '15'
    },
    ':holly:': {
        name: ':holly:',
        src: '/h/holidays.gif',
        width: '15',
        height: '15'
    },
    ':shithappens:': {
        name: ':shithappens:',
        src: '/s/shithappens.gif',
        width: '16',
        height: '16'
    },
    ':toast:': {
        name: ':toast:',
        src: '/t/toast.gif',
        width: '15',
        height: '16'
    },
    ':toaster:': {
        name: ':toaster:',
        src: '/t/toaster.gif',
        width: '20',
        height: '19'
    },
    ':peace:': {
        name: ':peace:',
        src: '/p/peace.gif',
        width: '15',
        height: '15'
    },
    ':eye:': {
        name: ':eye:',
        src: '/e/eye.gif',
        width: '15',
        height: '15'
    },
    ':santajark:': {
        name: ':santajark:',
        src: '/s/santajark.gif',
        width: '15',
        height: '16'
    },
    ':cynic:': {
        name: ':cynic:',
        src: '/c/cynic.gif',
        width: '20',
        height: '21'
    },
    ':kitty:': {
        name: ':kitty:',
        src: '/k/kitty.gif',
        width: '16',
        height: '16'
    },
    ':xmas:': {
        name: ':xmas:',
        src: '/x/xmas.gif',
        width: '15',
        height: '15'
    },
    ':santa:': {
        name: ':santa:',
        src: '/x/xmassanta.gif',
        width: '22',
        height: '20'
    },
    ':rudolph:': {
        name: ':rudolph:',
        src: '/x/xmasrudolph.gif',
        width: '24',
        height: '26'
    },
    ':worry:': {
        name: ':worry:',
        src: '/w/worry.gif',
        width: '15',
        height: '15'
    },
    ':blackrose:': {
        name: ':blackrose:',
        src: '/r/roseblack.gif',
        width: '15',
        height: '18'
    },
    ':jester:': {
        name: ':jester:',
        src: '/j/jester.gif',
        width: '15',
        height: '15'
    },
    ':sleepy:': {
        name: ':sleepy:',
        src: '/s/sleepy.gif',
        width: '15',
        height: '30'
    },
    ':snowflake:': {
        name: ':snowflake:',
        src: '/s/snowflake.png',
        width: '15',
        height: '15'
    },
    ':laughing:': {
        name: ':laughing:',
        src: '/l/laughing.gif',
        width: '15',
        height: '15'
    },
    ':alienxmas:': {
        name: ':alienxmas:',
        src: '/a/alienxmas.gif',
        width: '15',
        height: '20'
    },
    ':skullbones:': {
        name: ':skullbones:',
        src: '/s/skullbones2.gif',
        width: '20',
        height: '20'
    },
    ':pringles:': {
        name: ':pringles:',
        src: '/p/pringles.gif',
        width: '15',
        height: '15'
    },
    ':siamese:': {
        name: ':siamese:',
        src: '/s/siamesetwins.gif',
        width: '24',
        height: '15'
    },
    ':ufo:': {
        name: ':ufo:',
        src: '/u/ufo.gif',
        width: '15',
        height: '15'
    },
    ':penguin:': {
        name: ':penguin:',
        src: '/p/penguin.gif',
        width: '15',
        height: '20'
    },
    ':aww:': {
        name: ':aww:',
        src: '/a/aww.gif',
        width: '15',
        height: '15'
    },
    ':stormtrooper:': {
        name: ':stormtrooper:',
        src: '/s/stormtrooper.gif',
        width: '15',
        height: '15'
    },
    ':slamhead:': {
        name: ':slamhead:',
        src: '/s/slamhead.gif',
        width: '16',
        height: '16'
    },
    ':gadget:': {
        name: ':gadget:',
        src: '/g/gadget.gif',
        width: '19',
        height: '19'
    },
    ':groucho:': {
        name: ':groucho:',
        src: '/g/groucho.gif',
        width: '15',
        height: '15'
    },
    ':tribute:': {
        name: ':tribute:',
        src: '/f/flower.gif',
        width: '15',
        height: '15'
    },
    ':butterfly:': {
        name: ':butterfly:',
        src: '/b/butterfly.gif',
        width: '15',
        height: '17'
    },
    ':pirate:': {
        name: ':pirate:',
        src: '/p/pirate.gif',
        width: '15',
        height: '15'
    },
    ':cookie:': {
        name: ':cookie:',
        src: '/c/cookie.gif',
        width: '15',
        height: '15'
    },
    '=D': {
        name: '=D',
        src: '/b/biggrin.gif',
        width: '15',
        height: '15'
    },
    ':?': {
        name: ':?',
        src: '/c/confused.gif',
        width: '15',
        height: '30'
    },
    '8-)': {
        name: '8-)',
        src: '/c/cool.gif',
        width: '15',
        height: '15'
    },
    // tslint:disable-next-line
    ":'(": {
        // tslint:disable-next-line
        name: ":'(",
        src: '/c/cry.gif',
        width: '15',
        height: '15'
    },
    ':cry:': {
        name: ':cry:',
        src: '/c/cry.gif',
        width: '15',
        height: '15'
    },
    ':-o': {
        name: ':-o',
        src: '/e/eek.gif',
        width: '15',
        height: '15'
    },
    ':O': {
        name: ':O',
        src: '/e/eek.gif',
        width: '15',
        height: '15'
    },
    ':-O': {
        name: ':-O',
        src: '/e/eek.gif',
        width: '15',
        height: '15'
    },
    '=(': {
        name: '=(',
        src: '/f/frown.gif',
        width: '15',
        height: '15'
    },
    ':-(': {
        name: ':-(',
        src: '/f/frown.gif',
        width: '15',
        height: '15'
    },
    ':lick:': {
        name: ':lick:',
        src: '/l/lick.gif',
        width: '15',
        height: '20'
    },
    ':yum:': {
        name: ':yum:',
        src: '/letters/=p.gif',
        width: '15',
        height: '15'
    },
    ':lol:': {
        name: ':lol:',
        src: '/l/lol.gif',
        width: '15',
        height: '15'
    },
    ':skull:': {
        name: ':skull:',
        src: '/s/skull2.png',
        width: '19',
        height: '19'
    },
    ';-)': {
        name: ';-)',
        src: '/w/wink.gif',
        width: '15',
        height: '15'
    },
    ':upset:': {
        name: ':upset:',
        src: '/u/upset.gif',
        width: '15',
        height: '15'
    },
    '=)': {
        name: '=)',
        src: '/s/smile.gif',
        width: '15',
        height: '15'
    },
    ':-)': {
        name: ':-)',
        src: '/s/smile.gif',
        width: '15',
        height: '15'
    },
    ':p': {
        name: ':p',
        src: '/letters/=p.gif',
        width: '15',
        height: '15'
    },
    ':P': {
        name: ':P',
        src: '/letters/=p.gif',
        width: '15',
        height: '15'
    },
    '=p': {
        name: '=p',
        src: '/r/razz.gif',
        width: '15',
        height: '15'
    },
    ':x': {
        name: ':x',
        src: '/m/mad.gif',
        width: '15',
        height: '15'
    },
    ':-x': {
        name: ':-x',
        src: '/m/mad.gif',
        width: '15',
        height: '15'
    },
    ':X': {
        name: ':X',
        src: '/m/mad.gif',
        width: '15',
        height: '15'
    },
    ':-X': {
        name: ':-X',
        src: '/m/mad.gif',
        width: '15',
        height: '15'
    },
    '=|': {
        name: '=|',
        src: '/b/blankstare.gif',
        width: '15',
        height: '15'
    },
    ':deviator:': {
        name: ':deviator:',
        src: '/d/deviator.gif',
        width: '20',
        height: '20'
    },
    ':lock:': {
        name: ':lock:',
        src: '/l/locked.gif',
        width: '13',
        height: '16'
    },
    ':tea:': {
        name: ':tea:',
        src: '/t/tea.gif',
        width: '17',
        height: '15'
    },
    ':biscuit:': {
        name: ':biscuit:',
        src: '/c/cookie.gif',
        width: '15',
        height: '15'
    },
    ':mwahaha:': {
        name: ':mwahaha:',
        src: '/m/mwahaha.gif',
        width: '29',
        height: '15'
    },
    ':ambulance:': {
        name: ':ambulance:',
        src: '/a/ambulance.gif',
        width: '26',
        height: '21'
    },
    ':bow:': {
        name: ':bow:',
        src: '/b/bow.gif',
        width: '21',
        height: '16'
    },
    ':helpdesk:': {
        name: ':helpdesk:',
        src: '/h/helpdesk.gif',
        width: '36',
        height: '29'
    },
    ':jackdirt:': {
        name: ':jackdirt:',
        src: '/j/jackdirt.gif',
        width: '34',
        height: '29'
    },
    ':lemon:': {
        name: ':lemon:',
        src: '/l/lemon.gif',
        width: '20',
        height: '20'
    },
    ':blownose:': {
        name: ':blownose:',
        src: '/b/blownose.gif',
        width: '28',
        height: '20'
    },
    ':movingon:': {
        name: ':movingon:',
        src: '/m/movingon.gif',
        width: '43',
        height: '15'
    },
    ':heartbreaker:': {
        name: ':heartbreaker:',
        src: '/h/heartbreaker.gif',
        width: '43',
        height: '26'
    },
    ':teevee:': {
        name: ':teevee:',
        src: '/t/teevee.gif',
        width: '50',
        height: '26'
    },
    ':pie:': {
        name: ':pie:',
        src: '/p/pie.gif',
        width: '22',
        height: '22'
    },
    ':trash:': {
        name: ':trash:',
        src: '/t/trash.gif',
        width: '22',
        height: '25'
    },
    ':work:': {
        name: ':work:',
        src: '/w/work.gif',
        width: '48',
        height: '28'
    },
    ':writersblock:': {
        name: ':writersblock:',
        src: '/w/writersblock.gif',
        width: '22',
        height: '25'
    },
    ':tunes:': {
        name: ':tunes:',
        src: '/t/tunes.gif',
        width: '40',
        height: '25'
    },
    ':arc:': {
        name: ':arc:',
        src: '/a/arc.gif',
        width: '17',
        height: '19'
    },
    ':runnynose:': {
        name: ':runnynose:',
        src: '/r/runnynose.gif',
        width: '15',
        height: '15'
    },
    ':shamrock:': {
        name: ':shamrock:',
        src: '/s/shamrock.gif',
        width: '15',
        height: '15'
    },
    ':star:': {
        name: ':star:',
        src: '/s/star_full.gif',
        width: '17',
        height: '16'
    },
    ':star-empty:': {
        name: ':star-empty:',
        src: '/s/star_empty.gif',
        width: '17',
        height: '16'
    },
    ':star-half:': {
        name: ':star-half:',
        src: '/s/star_half.gif',
        width: '17',
        height: '16'
    },
    ';p': {
        name: ';p',
        src: '/w/winkrazz.gif',
        width: '15',
        height: '15'
    },
    ':explosion:': {
        name: ':explosion:',
        src: '/e/explosion.gif',
        width: '28',
        height: '18'
    },
    ':spotlight-left:': {
        name: ':spotlight-left:',
        src: '/s/spotlight-left.gif',
        width: '23',
        height: '22'
    },
    ':spotlight-right:': {
        name: ':spotlight-right:',
        src: '/s/spotlight-right.gif',
        width: '23',
        height: '22'
    },
    ':smooch:': {
        name: ':smooch:',
        src: '/s/smooch.gif',
        width: '35',
        height: '16'
    },
    ':worker:': {
        name: ':worker:',
        src: '/w/worker.gif',
        width: '33',
        height: '18'
    },
    ':tomgehrke:': {
        name: ':tomgehrke:',
        src: '/t/tomgehrke.gif',
        width: '17',
        height: '17'
    },
    ':olya:': {
        name: ':olya:',
        src: '/o/olya.gif',
        width: '20',
        height: '19'
    },
    ':flagcanada:': {
        name: ':flagcanada:',
        src: '/f/flagcanada.gif',
        width: '20',
        height: '13'
    },
    ':toocool:': {
        name: ':toocool:',
        src: '/t/toocool.gif',
        width: '15',
        height: '18'
    },
    ':mib:': {
        name: ':mib:',
        src: '/m/mib.gif',
        width: '36',
        height: '26'
    },
    ':paranoid:': {
        name: ':paranoid:',
        src: '/p/paranoid.gif',
        width: '23',
        height: '15'
    },
    ':strip:': {
        name: ':strip:',
        src: '/s/strip.gif',
        width: '21',
        height: '17'
    },
    ':twenty:': {
        name: ':twenty:',
        src: '/t/twenty.gif',
        width: '15',
        height: '15'
    },
    ':evileye:': {
        name: ':evileye:',
        src: '/e/evileye.gif',
        width: '15',
        height: '15'
    },
    ':angered:': {
        name: ':angered:',
        src: '/a/angered.gif',
        width: '21',
        height: '21'
    },
    ':achfoo:': {
        name: ':achfoo:',
        src: '/a/achfoo.gif',
        width: '32',
        height: '32'
    },
    ':faq:': {
        name: ':faq:',
        src: '/f/faq.gif',
        width: '33',
        height: '27'
    },
    ':spyedvsjark:': {
        name: ':spyedvsjark:',
        src: '/s/spyedvsjark.gif',
        width: '75',
        height: '25'
    },
    ':voodoo-prophet:': {
        name: ':voodoo-prophet:',
        src: '/v/voodoo-prophet.gif',
        width: '23',
        height: '20'
    },
    ':wow:': {
        name: ':wow:',
        src: '/w/wow.gif',
        width: '23',
        height: '15'
    },
    ':clone:': {
        name: ':clone:',
        src: '/c/clone.gif',
        width: '38',
        height: '18'
    },
    ':backstab:': {
        name: ':backstab:',
        src: '/b/backstab.gif',
        width: '42',
        height: '16'
    },
    ':poke:': {
        name: ':poke:',
        src: '/p/pokes.gif',
        width: '37',
        height: '17'
    },
    ':highfive:': {
        name: ':highfive:',
        src: '/h/highfive.gif',
        width: '45',
        height: '20'
    },
    ':phew:': {
        name: ':phew:',
        src: '/w/whew.gif',
        width: '25',
        height: '17'
    },
    ':cuddle:': {
        name: ':cuddle:',
        src: '/c/cuddle.gif',
        width: '24',
        height: '17'
    },
    ':thanks:': {
        name: ':thanks:',
        src: '/t/thanks.gif',
        width: '15',
        height: '15'
    },
    ':hypermind:': {
        name: ':hypermind:',
        src: '/h/hypermind.gif',
        width: '19',
        height: '19'
    },
    ':glomp:': {
        name: ':glomp:',
        src: '/g/glomp.gif',
        width: '47',
        height: '20'
    },
    ':fingerscrossed:': {
        name: ':fingerscrossed:',
        src: '/f/fingerscrossed.gif',
        width: '33',
        height: '15'
    },
    ':blackice:': {
        name: ':blackice:',
        src: '/b/blackice.gif',
        width: '28',
        height: '22'
    },
    ':nieman:': {
        name: ':nieman:',
        src: '/n/nieman.gif',
        width: '28',
        height: '22'
    },
    ':liquify:': {
        name: ':liquify:',
        src: '/l/liquify.gif',
        width: '28',
        height: '22'
    },
    ':surrender:': {
        name: ':surrender:',
        src: '/s/surrender.gif',
        width: '33',
        height: '20'
    },
    ':burp:': {
        name: ':burp:',
        src: '/b/burp.gif',
        width: '30',
        height: '15'
    },
    ':spank:': {
        name: ':spank:',
        src: '/s/spank.gif',
        width: '28',
        height: '20'
    },
    ':analprobe:': {
        name: ':analprobe:',
        src: '/a/analprobe.gif',
        width: '43',
        height: '27'
    },
    ':analprobestare:': {
        name: ':analprobestare:',
        src: '/a/analprobestare.gif',
        width: '47',
        height: '20'
    },
    ':greenprobe:': {
        name: ':greenprobe:',
        src: '/g/greenprobe.gif',
        width: '16',
        height: '16'
    },
    ':teleport:': {
        name: ':teleport:',
        src: '/t/teleport.gif',
        width: '65',
        height: '25'
    },
    ':yakuza:': {
        name: ':yakuza:',
        src: '/y/yakuza.gif',
        width: '50',
        height: '20'
    },
    ':ninjadart:': {
        name: ':ninjadart:',
        src: '/n/ninjadart.gif',
        width: '35',
        height: '30'
    },
    ':pointandlaugh:': {
        name: ':pointandlaugh:',
        src: '/p/pointandlaugh.gif',
        width: '25',
        height: '15'
    },
    ':begone:': {
        name: ':begone:',
        src: '/b/begone.gif',
        width: '15',
        height: '15'
    },
    ':snowing:': {
        name: ':snowing:',
        src: '/s/snowing.gif',
        width: '27',
        height: '37'
    },
    ':cling:': {
        name: ':cling:',
        src: '/c/comfort.gif',
        width: '38',
        height: '15'
    },
    ':threaten:': {
        name: ':threaten:',
        src: '/t/threaten.gif',
        width: '24',
        height: '22'
    },
    ':slyfart:': {
        name: ':slyfart:',
        src: '/s/slyfart.gif',
        width: '30',
        height: '15'
    },
    ':yawnstretch:': {
        name: ':yawnstretch:',
        src: '/y/yawnstretch.gif',
        width: '26',
        height: '19'
    },
    ':abduction:': {
        name: ':abduction:',
        src: '/a/abduction.gif',
        width: '20',
        height: '25'
    },
    ':deviation:': {
        name: ':deviation:',
        src: '/d/deviation.gif',
        width: '32',
        height: '18'
    },
    ':diny:': {
        name: ':diny:',
        src: '/d/dinyctis.gif',
        width: '37',
        height: '19'
    },
    ':jarkinajar:': {
        name: ':jarkinajar:',
        src: '/a/alienjar.gif',
        width: '23',
        height: '36'
    },
    ':sumo:': {
        name: ':sumo:',
        src: '/s/sumo.gif',
        width: '90',
        height: '20'
    },
    ':venox:': {
        name: ':venox:',
        src: '/k/kevin.gif',
        width: '22',
        height: '33'
    },
    ':kronix:': {
        name: ':kronix:',
        src: '/k/kronix.gif',
        width: '25',
        height: '25'
    },
    ':noir:': {
        name: ':noir:',
        src: '/n/noir.gif',
        width: '29',
        height: '25'
    },
    ':frail:': {
        name: ':frail:',
        src: '/f/frail.gif',
        width: '17',
        height: '15'
    },
    ':alphaosiris:': {
        name: ':alphaosiris:',
        src: '/a/alphaosiris.gif',
        width: '23',
        height: '25'
    },
    ':firelite-photo:': {
        name: ':firelite-photo:',
        src: '/f/firelite-photo.gif',
        width: '19',
        height: '28'
    },
    ':ninjaplot:': {
        name: ':ninjaplot:',
        src: '/n/ninjaplot.gif',
        width: '20',
        height: '23'
    },
    ':flageu:': {
        name: ':flageu:',
        src: '/e/europe.gif',
        width: '20',
        height: '13'
    },
    ':keiross:': {
        name: ':keiross:',
        src: '/k/keiross.gif',
        width: '25',
        height: '25'
    },
    ':flaguk:': {
        name: ':flaguk:',
        src: '/f/flaguk.gif',
        width: '20',
        height: '13'
    },
    ':halfliquid:': {
        name: ':halfliquid:',
        src: '/h/halfliquid.gif',
        width: '14',
        height: '14'
    },
    ':saddrunk:': {
        name: ':saddrunk:',
        src: '/s/saddrunk.gif',
        width: '26',
        height: '15'
    },
    ':ahoy:': {
        name: ':ahoy:',
        src: '/a/ahoy.gif',
        width: '31',
        height: '19'
    },
    ':jedi:': {
        name: ':jedi:',
        src: '/j/jedi.gif',
        width: '50',
        height: '20'
    },
    ':llama:': {
        name: ':llama:',
        src: '/l/llama.gif',
        width: '43',
        height: '97'
    },
    ':cweeks:': {
        name: ':cweeks:',
        src: '/c/cweeks.gif',
        width: '22',
        height: '29'
    },
    ':hexentanz:': {
        name: ':hexentanz:',
        src: '/h/hexentanz.gif',
        width: '23',
        height: '22'
    },
    ':manhug:': {
        name: ':manhug:',
        src: '/m/manhug.gif',
        width: '35',
        height: '17'
    },
    ':damphyr:': {
        name: ':damphyr:',
        src: '/d/damphyr.gif',
        width: '16',
        height: '16'
    },
    ':shakefish:': {
        name: ':shakefish:',
        src: '/s/shakefish.gif',
        width: '50',
        height: '50'
    },
    ':noes:': {
        name: ':noes:',
        src: '/n/noes.gif',
        width: '15',
        height: '15'
    },
    ':library:': {
        name: ':library:',
        src: '/l/library.gif',
        width: '50',
        height: '30'
    },
    ':chix0r:': {
        name: ':chix0r:',
        src: '/c/chix0r.gif',
        width: '23',
        height: '22'
    },
    ':film:': {
        name: ':film:',
        src: '/f/film.gif',
        width: '46',
        height: '21'
    },
    ':cough:': {
        name: ':cough:',
        src: '/c/cough.gif',
        width: '20',
        height: '20'
    },
    ':forgiveme:': {
        name: ':forgiveme:',
        src: '/f/forgiveme.gif',
        width: '28',
        height: '22'
    },
    ':onfire:': {
        name: ':onfire:',
        src: '/o/onfire.gif',
        width: '46',
        height: '34'
    },
    ':tighthug:': {
        name: ':tighthug:',
        src: '/t/tighthug.gif',
        width: '40',
        height: '18'
    },
    ':turbopoke:': {
        name: ':turbopoke:',
        src: '/t/turbopoke.gif',
        width: '40',
        height: '15'
    },
    ':pat:': {
        name: ':pat:',
        src: '/p/pat.gif',
        width: '35',
        height: '19'
    },
    ':trollface:': {
        name: ':trollface:',
        src: '/t/trollface.png',
        width: '21',
        height: '19'
    },
    ':empllama:': {
        name: ':empllama:',
        src: '/e/empllama.gif',
        width: '54',
        height: '19'
    },
    ':emplllama:': {
        name: ':emplllama:',
        src: '/e/emplllama.gif',
        width: '54',
        height: '19'
    },
    ':hooray:': {
        name: ':hooray:',
        src: '/h/hooray.gif',
        width: '26',
        height: '22'
    },
    ':wormnomnom:': {
        name: ':wormnomnom:',
        src: '/e/eat_worm_by_devlant-d3yzszv.gif',
        width: '24',
        height: '24'
    },
    ':leetcrab:': {
        name: ':leetcrab:',
        src: '/l/leetcrab.gif',
        width: '28',
        height: '25'
    },
    ':createwithpride:': {
        name: ':createwithpride:',
        src: '/p/pride_badge_x1.gif',
        width: '27',
        height: '27'
    },
    ':tutorialeye:': {
        name: ':tutorialeye:',
        src: '/t/tutorialeye-1x.gif',
        width: '27',
        height: '27'
    },
    ':tutorialhand:': {
        name: ':tutorialhand:',
        src: '/t/tutorialhand-1x.gif',
        width: '27',
        height: '27'
    },
    ':tutoriallandscape:': {
        name: ':tutoriallandscape:',
        src: '/t/tutoriallandscape-1x.gif',
        width: '27',
        height: '27'
    },
    ':tutorialspiderman:': {
        name: ':tutorialspiderman:',
        src: '/t/tutorialspiderman-1x.gif',
        width: '27',
        height: '27'
    },
    ':tutorialdragon:': {
        name: ':tutorialdragon:',
        src: '/t/tutorialdragon-1x.gif',
        width: '27',
        height: '27'
    },
    ':tutorialfire:': {
        name: ':tutorialfire:',
        src: '/t/tutorialfire-1x.gif',
        width: '27',
        height: '27'
    },
    ':tutorialwings:': {
        name: ':tutorialwings:',
        src: '/t/tutorialwings-1x.gif',
        width: '27',
        height: '27'
    },
    ':tutorialcat:': {
        name: ':tutorialcat:',
        src: '/t/tutorialcat-1x.gif',
        width: '27',
        height: '27'
    }
};

//# sourceMappingURL=official-emotes.js.map